import { Configuration, RedirectRequest } from '@azure/msal-browser'

import staticData from './staticData'

let environment = ''

//Map AD B2C tenantId to environment subdomain
switch(staticData.msalConfig?.tenantId) {
  case 'ce2a2c99-5c0e-45f3-90c3-4e7ea77d2a85':
    environment = 'partnerlogin-acc'
    break;
  case '6e067d63-7e36-481d-b24c-5963faf9dab1':
    environment = 'partnerlogin'
    break
}

const adB2cBaseUrl = `${environment}.transavia.com`
const adB2cBaseAuthority = `https://${adB2cBaseUrl}/tfp/${staticData.msalConfig?.tenantId}`

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: staticData.msalConfig?.clientId,
    authority: `${adB2cBaseAuthority}/B2C_1A_PARTNER_SIGNIN`,
    knownAuthorities: [adB2cBaseUrl],
    redirectUri: staticData.basePath,
    postLogoutRedirectUri: staticData.basePath,
  }
}

export function loginRequest(): RedirectRequest {
  const locale = `${staticData.lang}-${staticData.countryCode}`
  const adB2cLocale = determineAdB2cLocale(locale)

  return {
    scopes: ['openid'],
    extraQueryParameters: {
      locale: locale,
      ui_locales: adB2cLocale,
    },
  }
}

export function accessTokenRequest(): RedirectRequest {
  const request: RedirectRequest = { scopes: ['offline_access', `${process.env.REACT_APP_ALLOTMENT_SPACES_SCOPE}`] }

  if (sessionStorage.getItem('adb2c_access_token_policy')) {
    request.authority = `${adB2cBaseAuthority}/${sessionStorage.getItem('adb2c_access_token_policy')}`
  }

  return request
}

export function activateUserRequest(redirectUri: string, idTokenHint: string): RedirectRequest {
  const locale = `${staticData.lang}-${staticData.countryCode}`
  const adB2cLocale = determineAdB2cLocale(locale)

  return {
    scopes: ['openid'],
    authority: `${adB2cBaseAuthority}/B2C_1A_PARTNER_SIGNUPINVITATION`,
    redirectStartPage: redirectUri,
    extraQueryParameters: {
      locale: locale,
      ui_locales: adB2cLocale,
      id_token_hint: idTokenHint
    }
  }
}

function determineAdB2cLocale(locale: string) {
  let adB2cLocale = locale

  if (locale === 'en-NL') {
    adB2cLocale = 'en-US'
  }

  return adB2cLocale
}
